<template>
  <!-- eslint-disable-next-line vue/no-v-html -->
  <div class="u-typography-root cms-rich-text" v-html="$md.render(richText)" />
</template>

<script>
  export default {
    props: {
      richText: {
        type: String,
        required: true,
      },
    },
  }
</script>

<style lang="scss" src="./_cms-rich-text.scss" />
